export default "__VITE_ASSET__C9BN1buW__"